import { useLayoutEffect, useRef, useState, type ReactNode } from "react";

/** Keep measured space for offscreen cards while releasing their media and controls. */
export function VirtualItem({ children, date, enabled = true }: { children: ReactNode; date?: string; enabled?: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const height = useRef(0);
  const width = useRef(0);
  const [visible, setVisible] = useState(true);
  useLayoutEffect(() => {
    const node = ref.current;
    if (!enabled || !node || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;
      if (entry.isIntersecting) setVisible(true);
      else if (!node.contains(document.activeElement)) {
        height.current = node.getBoundingClientRect().height;
        if (height.current > 0) setVisible(false);
      }
    }, { root: node.closest("[data-results-scroll]"), rootMargin: "800px" });
    observer.observe(node);
    const resize = typeof ResizeObserver === "undefined" ? undefined : new ResizeObserver(([entry]) => {
      if (!entry) return;
      if (width.current && Math.abs(width.current - entry.contentRect.width) > 1) setVisible(true);
      width.current = entry.contentRect.width;
    });
    resize?.observe(node);
    return () => { observer.disconnect(); resize?.disconnect(); };
  }, [enabled]);
  return <div ref={ref} className="min-w-0" style={visible || !enabled ? undefined : { height: height.current }}
    data-scroll-date={!visible && enabled ? date : undefined} aria-hidden={(!visible && enabled) || undefined}>
    {visible || !enabled ? children : null}
  </div>;
}
